<template>
  <v-content>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <DataTable v-if='!userdocuments.hasOwnProperty("stage_1") && !userdocuments.hasOwnProperty("stage_2")'  :title="title" :headers="headers" :items="userdocuments" :search="search" @openSettingsDialog='openSettingsDialog' />
          <DataTable v-if='userdocuments.hasOwnProperty("stage_1")' :title="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.user_documents : []" :search="stage1search" @openSettingsDialog='openSettingsDialog' :settingsstatus='valid' />
          <br /><br />
          <DataTable v-if='userdocuments.hasOwnProperty("stage_2")' :title="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.user_documents : []" :search="stage2search"  />

        <v-dialog v-model="settingsdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Set Filter'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 1'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      v-model="set_name_stage_1"
                      :rules="stage1name"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show next' | translate"
                      v-model="due_days_stage_1"
                      type="number"
                      :rules="duedays1"
                    ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 2'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      v-model="set_name_stage_2"
                      :rules="stage2name"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show from' | translate"
                      v-model="due_days_stage_2"
                      :rules="duedays2"
                      type="number"
                    ></v-text-field>
                    </v-col>
                  </v-row>

                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="settingsdialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" text @click="clearsettings()">{{ 'Clear'| translate }}</v-btn>  
              <v-btn color="blue darken-1" text @click="setFilter()">{{ 'Save'| translate }}</v-btn>              
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>


<script>
import store from "@/store"
import { mapGetters } from "vuex"
import { FETCH_USER_DOCUMENTS, CLEAR_INBOX_SETTINGS,FETCH_INBOX_SETTINGS,SAVE_UPDATE_INBOX_SETTINGS } from "@/store/actions.type"
import { SET_LOADING } from "@/store/mutations.type"

export default {
  name: "Inbox",
  beforeRouteEnter(to, from, next) {
    store.dispatch(FETCH_USER_DOCUMENTS,'').then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
      }
    });
    return next();
  },
  created(){
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false){
      this.$router.push('/learningcenter');
    }
  },
  data: function() {
    return {
      title: "Inbox",
      headers: [
        { text: this.$t("Name"), value: "user_name" },   
        { text: this.$t("Type"), value: "doc_name" }, 
        { text: this.$t("Status"), value: "status" },
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "linktouser", sortable: false }
      ],
      search: "",
      singleSelect: "",
      settingsdialog : false,
      set_name_stage_1: null,
      set_name_stage_2: null,
      due_days_stage_1: null,
      due_days_stage_2: null,
      stage1search: "",
      stage2search: "",
      valid: 'true',
      stage1name: [v => !!v || this.$t("Name is required")],
      stage2name: [v => !!v || this.$t("Name is required")],
      duedays1: [v => !!v || this.$t("Due days is required")],
      duedays2: [v => !!v || this.$t("Due days is required")],
    };
  },
  methods: {
    async openSettingsDialog(){
      await this.$store.dispatch(FETCH_INBOX_SETTINGS,'inbox').then( resp =>{
        if(resp.success){
          this.set_name_stage_1 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.set_name : "")
          this.set_name_stage_2 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.set_name : "")
          this.due_days_stage_1  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.due_days : "")
          this.due_days_stage_2  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.due_days : "")
          this.settingsdialog = true
          store.commit(SET_LOADING, false)
        }
      })      
    },
    closeSettingsDialog(){
      this.settingsdialog = false
      this.$refs.form.reset()      
      this.set_name_stage_1 = ''
      this.due_days_stage_1  = ''
      this.set_name_stage_2 = ''
      this.due_days_stage_2 = ''

    },
    async clearsettings(){
      await this.$store.dispatch(CLEAR_INBOX_SETTINGS,'inbox').then( async resp =>{
        if(resp.success){
            this.settingsdialog = false
            this.$refs.form.reset()                
            this.set_name_stage_1 = ''
            this.due_days_stage_1  = ''
            this.set_name_stage_2 = ''
            this.due_days_stage_2 = ''
            await this.$store.dispatch(FETCH_USER_DOCUMENTS,'').then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false)
              }
            })


        
        }
      })      
    },      

    async setFilter(){
      if (this.$refs.form.validate()) {
        await this.$store.dispatch(SAVE_UPDATE_INBOX_SETTINGS, {
          'stage_1':{ set_name: this.set_name_stage_1, due_days: this.due_days_stage_1 },
          'stage_2':{ set_name: this.set_name_stage_2, due_days: this.due_days_stage_2 }
        }).then(async resp => {
          if(resp.success){
            await this.$store.dispatch(FETCH_USER_DOCUMENTS,'').then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false)
                this.set_name_stage_1 = ''
                this.due_days_stage_1  = ''
                this.set_name_stage_2 = ''
                this.due_days_stage_2 = ''                
                this.settingsdialog = false
                this.$refs.form.reset()
              }
            })            
          }

        });

      }
    }
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable")
  },
  computed: {
    ...mapGetters(["userdocuments","currentUser",'inboxsettings'])
  }
};
</script>